import React, { useCallback, useContext, useEffect, useState } from "react";
import { AlertContext } from "../../contexts/AlertContext";
import { SocketContext } from "../../contexts/SocketContext";
import { LoaderContext } from "../../contexts/LoaderContext";
import { ModalsContext } from "../../contexts/ModalsContext";
import { CreateChannelForm } from "../../components/surveys/channels/CreateChannelForm";
import { convertirLetraMayus } from "../../helpers/convertirLetraMayus";
import { Actions } from "../../components/surveys/channels/Actions";
import { useModalStore } from "../../store/useModalStore";

const columns = [
    { id: "canal", label: "Canal", minWidth: 170, align: 'center' },
    { id: "interno", label: "Tipo", minWidth: 170, align: 'center' },
    { id: "estado", label: "Estado", minWidth: 170, align: 'center' },
    { id: "acciones", label: "Acciones", minWidth: 170, align: 'center' }
];

export const useChannels = () => {

    const [channels, setChannels] = useState([]);

    // const { modalRef } = useContext(ModalsContext);
    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { openModal, closeModal } = useModalStore();

    useEffect(() => {
        let subscribed = true;
        
        if(subscribed) 
            setOpenLoader(true);
            getChannels();

        return () => subscribed = false;
    }, []);

    const searchChannel = (value) => { 
        socket.emit('frontend:buscar-canal', { canal: value?.trim() }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                alertRef.current?.handleOpen('error', message);
                return;
            }
          
            setChannels(data?.map(d => generatePayload(d)));
        });
    }

    // const addChannel = () => {
    //     modalRef.current.handleOpen(<CreateChannelForm action={ (data) => saveChannel(data)  } />, 'auto', 'auto');
    // }

    const addChannel = () => openModal(<CreateChannelForm action={ (data) => saveChannel(data)  } />);

    const getChannels = useCallback(() => {
        socket.emit('frontend:obtener-canales', (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            const newArr = data?.map(generatePayload);
            setChannels(newArr);
            setOpenLoader(false);
        });
    }, []);

    const saveChannel = (args) => {
        setOpenLoader(true);
        const { canal, interno } = args;
        socket.emit('frontend:crear-canal', { canal: canal?.trim(), interno: Boolean(interno) }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setChannels(prev => ([...prev, generatePayload(data)]));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const updateChannel = (args) => {
        setOpenLoader(true);
        const { _id, canal, interno, activo} = args;
        socket.emit('frontend:actualizar-canal', { _id, canal: canal?.trim(), interno: Boolean(interno), activo: Boolean(activo) }, response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setChannels(prev => prev?.map(p => p?._id === _id ? generatePayload(data) : p ));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const deleteChannel = (_id) => {
        setOpenLoader(true);
        socket.emit('frontend:eliminar-canal', { _id }, response => {
            const { ok, message } = response;

            if(!ok) {
                setOpenLoader(false);
                // modalRef.current?.handleClose();
                closeModal();
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setChannels(prev => prev?.filter(p => p._id !== _id));
            // modalRef.current?.handleClose();
            closeModal();
            setOpenLoader(false);
        });
    }

    const generatePayload = (data) => ({
        ...data,
        canal: convertirLetraMayus(data?.canal),
        interno: data?.interno ? 'Físico' : 'Virtual',
        estado: data?.activo ? 'Activo' : 'Inactivo',
        acciones: <Actions data={ data } updated={updateChannel} deleted={ deleteChannel } />
    });

    return {
        columns,
        channels,
        addChannel,
        searchChannel
    }
}